<template>
  <form @submit.prevent="addStaf" method="post">
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <div slot="header">
            <strong>{{caption}}</strong>
          </div>

          <b-row>
            <b-col sm="12" v-if="errores.length">
              <b-alert show variant="danger">
                <b>Por favor corrige los siguientes errores:</b>
                <ul>
                  <li v-for="error in errores" :key="error">{{ error }}</li>
                </ul>
              </b-alert>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group>
                <label for="cmbTipo">Tipo</label>
                <b-form-select v-model="staff.type" id="cmbTipo">
                  <template slot="first">
                    <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                  </template>
                  <option v-for="item in lstType" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group>
                <label for="cmbTipoDocumento">Tipo documento</label>
                <b-form-select v-model="staff.identification_type" id="cmbTipoDocumento">
                  <template slot="first">
                    <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                  </template>
                  <option
                    v-for="item in lstTipoDocumento"
                    :key="item.id"
                    :value="item.id"
                  >{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label for="txtIdentificacion">Identificación</label>
                <b-form-input type="text" id="txtIdentificacion" v-model="staff.identification"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="txtNombre">Nombre(s)</label>
                <b-form-input type="text" id="txtNombre" v-model="staff.name"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label for="txtApellido">Apellido(s)</label>
                <b-form-input type="text" id="txtApellido" v-model="staff.last_name"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group>
                <label for="txtTelefono">Teléfono</label>
                <b-form-input type="text" id="txtTelefono" v-model="staff.phone"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <label for="txtCelular">Celular</label>
                <b-form-input type="text" id="txtCelular" v-model="staff.mobile"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <label for="txtDireccion">Dirección</label>
                <b-form-input type="text" id="txtDireccion" v-model="staff.address"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group
                validated
                label="E-mail personal"
                label-for="txtEmailPersonal"
                description="Por favor ingrese su correo electrónico  personal."
              >
                <b-form-input
                  id="txtEmailPersonal"
                  type="email"
                  placeholder="ejemplo@email.com"
                  required
                  v-model="staff.personal_mail"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group
                validated
                label="E-mail trabajo"
                label-for="txtEmailTrabajo"
                description="Por favor ingrese su correo electrónico del trabajo."
              >
                <b-form-input
                  id="txtEmailTrabajo"
                  type="email"
                  placeholder="ejemplo@email.com"
                  v-model="staff.business_mail"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="rbtEstado">Estado</label>

                <b-form-radio-group id="grbtEstado" name="rbtEstado">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="rbtEstadoA"
                      name="rbtEstado"
                      class="custom-control-input"
                      value="A"
                      v-model="staff.status"
                    />
                    <label class="custom-control-label" for="rbtEstadoA">Activo</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="rbtEstadoI"
                      name="rbtEstado"
                      class="custom-control-input"
                      value="I"
                      v-model="staff.status"
                    />
                    <label class="custom-control-label" for="rbtEstadoI">Inactivo</label>
                  </div>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <hr />
            <h4>Configuración</h4>
          </b-form-group>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="cmbUsuario">Usuario</label>
                <b-form-select v-model="staff.user_id" class="mb-3" id="cmbUsuario">
                  <template slot="first">
                    <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                  </template>

                  <option v-for="item in lstUsers" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button @click="goBack" variant="primary" class="mr-1">Cancelar</b-button>

          <b-button type="submit" variant="success">Guardar</b-button>
        </b-card>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  name: "stafAdd",
  props: {
    caption: {
      type: String,
      default: "Funcionario"
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      lstTipoDocumento: [],
      lstUsers: [],
      lstType: [],
      staff: {
        name: "",
        last_name: "",
        identification_type: null,
        identification: "",
        phone: "",
        mobile: "",
        personal_mail: "",
        business_mail: "",
        address: "",
        user_id: null,
        is_boss: null,
        signature: null,
        type: null,
        status: "A"
      },
      datos: [],
      errores: []
    };
  },
  mounted() {
    // LISTADO DE TIPOS DE DOCUMENTO
    this.$http.get(`${this.$urlApi}parameters/2?token=${this.token}`).then(
      response => {
        this.lstTipoDocumento = response.data.data;
      },
      error => {
        console.log(error);
      }
    );

    // LISTADO DE TIPOS DE STAFF
    this.$http.get(`${this.$urlApi}parameters/10?token=${this.token}`).then(
      response => {
        this.lstType = response.data.data;
      },
      error => {
        console.log(error);
      }
    );

    //LISTADO DE USUARIOS
    this.$http.get(`${this.$urlApi}users?token=${this.token}`).then(
      response => {
        this.lstUsers = response.data.data;
      },
      error => {
        console.log(error);
      }
    );
  },
  computed: {},
  methods: {
    addStaf() {
      showLoader();
      this.datos = JSON.stringify(this.staff);
      console.log(this.datos);

      //return false

      this.$http
        .post(`${this.$urlApi}staffs?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" }
        })
        .then(function(response) {
          console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              location.href = `${location.origin}/#/staffs`;
            }
          });
        })
        .catch(error => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
